import React from 'react';
import { Link } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';

type TAutosFeedsSurveyLink = {
  exploreMoreSurveyUrl: string;
};

const AutosFeedsSurveyLink: React.FC<TAutosFeedsSurveyLink> = ({ exploreMoreSurveyUrl }) => {
  const { t } = useI18nContext();

  return (
    <Link href={exploreMoreSurveyUrl} target="_blank">
      {t('homepage.exploreMore.surveyLink')}
    </Link>
  );
};

export default AutosFeedsSurveyLink;
